<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">
          Message
        </v-card-title>
        <v-card-text>{{$t('Unfortunately at this time, we are unable to bill Medicare, Tricare, or Medicaid plans from states other than Washington.')}} </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click='$emit("back")'
          >
            {{$t('Okay')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-title>{{$t('Please enter your insurance information below')}}:</v-card-title>
      <v-divider></v-divider>
      <v-form
        class='pt-5'
        ref="form"
        v-model="valid"
      >
        <v-row>
          <v-col
            class='pa-5 pb-0'
            cols="12"
          >
            <v-select
              @change='stateCheck'
              :items="insuranceDropdown"
              v-model="formData.insuraceType"
              :rules="requireRule"
              :label="$t('Insurance Type')"
              :placeholder="$t('Insurance Type')"
              persistent-placeholder
              required
              outlined
            ></v-select>
          </v-col>
          <v-col
            class='pa-5 pb-0'
            cols="12"
          >
            <v-text-field
              v-model="formData.planName"
              :rules="requireRule"
              :label="$t('Insurance Plan Name')"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            class='pa-5 pb-0'
            cols="12"
          >
            <v-text-field
              v-model="formData.groupName"
              :label="$t('Insurance Group Name')"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            class='pa-5 pb-0'
            cols="12"
          >
            <v-text-field
              v-model="formData.insuranceID"
              :rules="requireRule"
              :label="$t('Insurance ID')"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            class='pa-5 pb-0'
            cols="12"
          >
            <v-text-field
              v-model="formData.insuranceGroup"
              :label="$t('Insurance Group Number')"
              required
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card-title>{{$t('Upload a copy of your insurance card (front and back side)')}}</v-card-title>
        <v-file-input
          @change='onFileChange'
          v-model='uploadfiles'
          chips
          multiple
          :label="$t('Upload Files here')"
        ></v-file-input>

      </v-form>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click='$emit("back")'
        >
          <v-icon
            right
            dark
          >
            mdi-chevron-left
          </v-icon>
          {{$t('Back')}}
        </v-btn>

        <v-btn
          @click='payment'
          :loading="loadingBtn"
          text
          color='green'
        >

          {{$t('Next')}}
          <v-icon
            right
            dark
          >
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </v-card-actions>

    </v-card>
  </div>
</template>

<script>
import { insuranceType, stateList } from "../data/dataSource";
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    language: String,
  },
  mounted() {
    console.log(this.language);
  },
  watch: {
    language(val) {
      this.insuranceDropdown = insuranceType(val);
    },
  },
  computed: {
    ...mapFields([
      "uploadId",
      "form",
      "selectedStateID",
      "selectedMonth",
      "selectedDate",
      "selectedGC",
      "selectedTime",
    ]),
  },
  methods: {
    getBase64(file, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        callback(reader.result.replace("data:", "").replace(/^.+,/, ""))
      );
      reader.readAsDataURL(file);
    },

    onFileChange() {
      this.uploadfiles.forEach((file) => {
        //convert to base64
        this.getBase64(file, (base64) => {
          this.form.filesBase64.push({
            fileName: file.name,
            fileType: file.type,
            baseString: base64,
          });
        });
      });
    },
    getInsuraceState(selectedStateID) {
      return stateList().find((s) => s.stateID === selectedStateID).insuraceID;
    },
    async payment() {
      this.valid = this.$refs.form.validate();

      if (this.valid) {
        this.loadingBtn = true;
        for (const file of this.filesBase64) {
          await this.$axios.post(
            "https://us-central1-gsf-ehr.cloudfunctions.net/public/guestUpload",
            {
              uploadID: this.uploadId,
              fileName: file.fileName,
              fileType: file.fileType,
              baseString: file.baseString,
            }
          );
        }

        this.loadingBtn = false;

        let confirm_url = `12813864&appointmentType=${this.getInsuraceState(
          this.selectedStateID
        )}&firstName=${this.form.firstName}&lastName=${
          this.form.lastName
        }&phone=${this.form.phone}&email=${this.form.email}&calendarID=${
          this.selectedGC
        }&datetime=${this.selectedTime}&field:9184733=${
          this.form.dob
        }&field:9184730=${this.form.secondPhone}&field:9184732=${
          this.form.address
        }&field:9184731[]=${this.form.gender}&field:9184735[]=${
          this.form.reason
        }&field:9184736=${this.form.notes}&field:9184734=${
          this.form.firstTime
        }&timezone=${this.form.timezone.name}&field:9184737=${
          this.form.aboutGSF
        }&field:9184783=${this.formData.insuraceType}&field:9184785=${
          this.formData.planName
        }&field:9184787=${this.formData.groupName}&field:9184789=${
          this.formData.insuranceID
        }&field:9265604=${this.uploadId}&field:9184792=${
          this.formData.insuranceGroup
        }`;
        let formattedURL = encodeURI(confirm_url);
        formattedURL = formattedURL.replace(/#/g, "%23");
        let url =
          "https://app.acuityscheduling.com/schedule.php?owner=" + formattedURL;
        window.open(url, "_self");
      }
    },
    stateCheck(val) {
      if (this.form.state !== "WA") {
        switch (val) {
          case "Medicare":
          case "Tricare":
          case "Medicaid":
            this.dialog = true;

            break;
        }
      }
    },
  },
  data() {
    return {
      loadingBtn: false,
      filesBase64: [],
      uploadfiles: [],
      dialog: false,
      insuranceDropdown: insuranceType(this.language),
      requireRule: [(v) => !!v || "This field is required"],
      formData: {
        insuraceType: null,
        planName: null,
        groupName: null,
        insuranceID: null,
        insuranceGroup: null,
      },
      valid: false,
    };
  },
};
</script>

<style>
</style>